module.exports = __webpack_public_path__ + "img/Joboffer.6ce24fb5.svg";